export default {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_ENDPOINTS: 'SET_ENDPOINTS',
  SET_MR_METADATA: 'SET_MR_METADATA',
  SET_FAILED_TO_LOAD_METADATA: 'SET_FAILED_TO_LOAD_METADATA',
};
